import React, { FC } from 'react';
import { Card } from 'Shared/components/Card';

import { CardError, CardHeader } from 'Shared/components';
import { MailDocuments } from './MailDocuments/MailDocuments';
import { usePolicyContext } from 'Policies/utils/PolicyContext/PolicyContext';
import { DocumentList } from './DocumentList/DocumentList';
import { useDocumentsContext } from 'Policies/utils/DocumentsContext';

export const PolicyDocuments: FC<{}> = () => {
  const { error, refetch } = useDocumentsContext();

  const {
    details: { isPolicyDraft, isRenewalDraft },
    systemOfRecord,
  } = usePolicyContext();

  if (isRenewalDraft || isPolicyDraft) return null;
  return (
    <Card id="Documents">
      <CardHeader title={'Documents'}>
        {systemOfRecord === 'clearcover' && <MailDocuments />}
      </CardHeader>
      <DocumentList />
      <CardError error={error} refetch={refetch} />
    </Card>
  );
};
